import React, { useEffect } from 'react'

import { Spinner } from '@wartek-id/spinner'

import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

type PageGuardKSPNFProps = {
  children: React.ReactNode
  allowKepalaPkbmOrKb?: boolean
}

export function PageGuardKSPNF({
  children,
  allowKepalaPkbmOrKb,
}: PageGuardKSPNFProps) {
  const { isKepalaSkb, isKepalaPkbmOrKb, isSuccess, leave } = useRoleContext()

  const isKepalaPkbmOrKbEligible = allowKepalaPkbmOrKb && isKepalaPkbmOrKb

  useEffect(() => {
    if (isSuccess && !(isKepalaSkb || isKepalaPkbmOrKbEligible)) {
      leave()
    }
  }, [isSuccess, isKepalaSkb, leave, isKepalaPkbmOrKbEligible])

  if (!isSuccess || !(isKepalaSkb || isKepalaPkbmOrKbEligible))
    return (
      <div className="flex p-10">
        <div className="m-auto">
          <Spinner data-testid="loading-spinner-content" />
        </div>
      </div>
    )

  return <>{children}</>
}
